import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip
} from '@mui/material';

function RecentDeals({ deals }) {
  if (!deals || deals.length === 0) {
    return (
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>Recent Deals</Typography>
        <Typography color="text.secondary">No recent deals found.</Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Recent Deals</Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Vehicle</TableCell>
              <TableCell align="right">Price</TableCell>
              <TableCell align="right">Savings</TableCell>
              <TableCell align="center">Score</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deals.map((deal, index) => (
              <TableRow key={deal.id || index}>
                <TableCell>
                  {deal.year} {deal.make} {deal.model}
                </TableCell>
                <TableCell align="right">
                  ${(deal.price || 0).toLocaleString()}
                </TableCell>
                <TableCell align="right" sx={{ color: 'success.main' }}>
                  ${(deal.savings || 0).toLocaleString()}
                </TableCell>
                <TableCell align="center">
                  <Chip
                    label={deal.score || 'N/A'}
                    color={deal.score >= 80 ? 'success' : deal.score >= 50 ? 'warning' : 'default'}
                    size="small"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default RecentDeals;
